import React, { useState, useEffect, forwardRef, useRef, Fragment } from "react";
import { Button } from '../../components/Wrappers'
import { TextField, InputAdornment,
         FormControl, InputLabel, Select, Input, Chip, MenuItem,
         NativeSelect} from "@material-ui/core";
import enNZ from 'date-fns/locale/en-NZ'
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Icons
import {
    CalendarToday as CalendarTodayIcon,
    HomeWork as HomeWorkIcon
} from '@material-ui/icons'

import { useUserState } from "../../context/UserContext";
import useStyles from './styles';
import config from '../../config';
import classnames from "classnames";
import "./Finance.css";

registerLocale('en-NZ', enNZ);


const Finance = forwardRef((props, ref) => {
    var classes = useStyles();
    var { regions } = useUserState();
    const fromRef = useRef(null);
    const fromCalendarRef = useRef(null);
    const [selectedFrom, setSelectedFrom] = React.useState(null);
    const [fromFocused, setFromFocused] = React.useState(false);
    const toRef = useRef(null);
    const toCalendarRef = useRef(null);
    const [selectedTo, setSelectedTo] = React.useState(null);
    const [toFocused, setToFocused] = React.useState(false);
    var currentFromValue = null;
    var currentToValue = null;
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [regionSelectionOpen, setRegionSelectionOpen] = React.useState(false);
    const [selectedIsAll, setSelectedIsAll] = React.useState('YES');

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };

    /*useEffect(() => {
      if (fromCalendarRef !== undefined && fromCalendarRef !== null &&
        fromCalendarRef.current !== undefined && fromCalendarRef.current !== null) {
        fromCalendarRef.current.setOpen(fromFocused);
      }
    },[fromFocused]);*/

    useEffect(() => {
      const to = new Date();
      const from = new Date(to);
      from.setDate(to.getDate() - 13); // last 14 days including today
      setSelectedFrom(from);
      setSelectedTo(to);
    }, []);


    const handleChange = (event) => {
        setSelectedRegion(event.target.value);
    };

    const handleDelete = () => {
      setSelectedRegion(null);
    };


    const onMouseDown = e => {
      e.stopPropagation();
    };

    // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
    function handleChangeFrom(d) {
      currentFromValue = d;
    }

    function handleChangeTo(d) {
      currentToValue = d;
    }

    function onFocusFrom(event) {
      setFromFocused(true);
    }

    function onFocusTo(event) {
      setToFocused(true);
    }

    function blurFrom(event) {
      setFromFocused(false);
    }

    function blurTo(event) {
      setToFocused(false);
    }

    function handleSelectFrom(d) {
      setSelectedFrom(d);
    }

    function handleSelectTo(d) {
      setSelectedTo(d);
    }

    // triggered if use keyboard
    function handleFromKeyPress(event) {
      if (event.which === 9 || event.which === 13 || event.which === 27) {
        setFromFocused(false);
      }
    }

    function handleToKeyPress(event) {
      if (event.which === 9 || event.which === 13 || event.which === 27) {
        setToFocused(false);
      }
    }

    function handleChangeIsAll(e) {
      const value = e.target.value;
      setSelectedIsAll(value);

      if (value === 'YES') {
        setSelectedRegion(null);
      }
    }

    function formatDateYYYYMMDD(d) {
      if (!d) return null;
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    function generateFinanceReport() {
      const fromStr = formatDateYYYYMMDD(selectedFrom);
      const toStr = formatDateYYYYMMDD(selectedTo);

      // single region (or null for all)
      const regionId =
        selectedRegion && selectedRegion.id ? selectedRegion.id : null;

      const baseUrl = `${config.clientApi}/report/finance_summary_workbook`;

      const params = [
        fromStr ? `from=${fromStr}` : null,
        toStr ? `to=${toStr}` : null,
        regionId ? `region_id=${regionId}` : null
      ]
        .filter(Boolean)
        .join('&');

      const url = params ? `${baseUrl}?${params}` : baseUrl;

      console.log(url);
      window.open(url, '_blank');
    }



    return (
      <>

                <div className={classes.reportCalendars}>
                    <TextField
                      id="from"
                      ref={fromRef}
                      label="From"
                      className={classnames({
                      'textField': true,
                      'reportCalendarField': true,
                      [classes.calendarFocused]: fromFocused
                    })}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                              <CalendarTodayIcon />
                            </InputAdornment>
                          ),
                          inputComponent: () =>
                          <DatePicker
                          ref={fromCalendarRef}
                          className={classes.textField}
                          selected={selectedFrom}
                          onChange={handleChangeFrom}
                          onFocus={onFocusFrom}
                          onSelect={handleSelectFrom}
                          onClickOutside={blurFrom}
                          onKeyDown={handleFromKeyPress}
                          locale="en-NZ"
                          timeIntervals={30}
                          dateFormat="dd/MM/yyyy"
                          />
                        }}
                    />
                    <TextField
                      id="to"
                      ref={toRef}
                      label="To"
                      className={classnames({
                      'textField': true,
                      'reportCalendarField': true,
                      [classes.calendarFocused]: toFocused
                    })}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                              <CalendarTodayIcon />
                            </InputAdornment>
                          ),
                          inputComponent: () =>
                          <DatePicker
                          ref={toCalendarRef}
                          className={classes.textField}
                          selected={selectedTo}
                          onChange={handleChangeTo}
                          onFocus={onFocusTo}
                          onSelect={handleSelectTo}
                          onClickOutside={blurTo}
                          onKeyDown={handleToKeyPress}
                          locale="en-NZ"
                          timeIntervals={30}
                          dateFormat="dd/MM/yyyy"
                          />
                        }}
                    />

                </div>


                <FormControl variant="outlined" className={classnames({
                      'isAllRegionsSelect':  true,
                      'workload-select-control': true
                    })}>
                  <InputLabel id="is_all">All Regions?</InputLabel>
                  <div className={classnames({
                                'select-control-input': true
                              })}>
                    <NativeSelect
                      value={selectedIsAll}
                      onChange={handleChangeIsAll}
                    >
                       <option value="YES">YES</option>
                       <option value="NO">NO</option>
                    </NativeSelect>
                  </div>
                </FormControl>

                {selectedIsAll === 'NO' && <FormControl variant="outlined"
                             className={classnames(classes.regions, {
                              'regions-control': true
                            })}>
                  <InputLabel id="regions-label">Regions</InputLabel>
                  <div className={classnames(classes.regionsInput, {
                                'regions-control-input': true
                              })}>
                  <InputAdornment position="start">
                    <HomeWorkIcon />
                  </InputAdornment>
                  <Select
                      labelId="regions-label"
                      id="region"
                      className={classes.regionsSelect}
                      value={selectedRegion}
                      onChange={(e) => {
                        setSelectedRegion(e.target.value);
                        setRegionSelectionOpen(false);
                      }}
                      open={regionSelectionOpen}
                      onClose={() => setRegionSelectionOpen(false)}
                      onOpen={() => setRegionSelectionOpen(true)}
                      input={<Input id="region-chip" />}
                      renderValue={(selected) =>
                        selected ? (
                          <Chip
                            label={selected.name}
                            className={classes.chip}
                            variant="outlined"
                            onMouseDown={onMouseDown}
                          />
                        ) : null
                      }
                      MenuProps={MenuProps}
                      size="small"
                    >
                      {regions && regions.map(region => (
                        <MenuItem
                          key={region.id}
                          value={region}
                          onClick={() => setRegionSelectionOpen(false)}
                        >
                          <span className="dropdown-avatar">{region.name}</span>
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </FormControl>}


                <div className={classes.layoutButtonsRow}>
                    <Button onClick={generateFinanceReport} >
                      <span>create</span>
                    </Button>
                </div>

      </>
    );
});

export default Finance;
